@if (container() === 'card') {
  <ng-container *ngTemplateOutlet="payFlowInfo"></ng-container>
}
@if (container() === 'dialog') {
  <umss-button
    [label]="'Pay schedule/flow'"
    [variant]="'Ghost'"
    [leftIconName]="'phosphorInfo'"
    (onClick)="openDialog()"
  ></umss-button>

  <umss-dialog [open]="isOpen()" (onClose)="closeDialog()">
    <umss-dialog-header
      title="Pay Schedule / Flow"
      [showCloseButton]="true"
      (onClose)="closeDialog()"
    />
    <ng-container *ngTemplateOutlet="payFlowInfo"></ng-container>
  </umss-dialog>
}

<ng-template #payFlowInfo>
  <article
    [class.in-card]="container() === 'card'"
    [class.in-dialog]="container() === 'dialog'"
  >
    @if (container() === 'card') {
      <h4>Pay Schedule / Flow</h4>
    }

    <ol>
      @for (item of flowInfo[type()]; track $index) {
        <li
          class="pg-small-regular"
          [style.color]="'var(--color-text-text-secondary)'"
        >
          {{ item }}
        </li>
      }
    </ol>
  </article>
</ng-template>
